import { FactoryProvider } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { CART_MESSAGES_TRANSLATIONS, CartMessagesTranslations } from '@hdms/shared/common-types';

export const CART_MESSAGES_TRANSLATIONS_PROVIDER: FactoryProvider = {
  provide: CART_MESSAGES_TRANSLATIONS,
  deps: [I18NEXT_SERVICE],
  useFactory: (i18NextService: ITranslationService): CartMessagesTranslations => ({
    addToCartSuccessTitle: i18NextService.t('cart.addToCart.message.success.title'),
    goToCartLabel: i18NextService.t('common.label.button.goToCart'),
    addToCartSuccessMessage: (count: number, name?: string) =>
      i18NextService.t('cart.addToCart.message.success.copy', { count, name, context: name ? 'withName' : null }),
    roundUpMessage: {
      headline: i18NextService.t('cart.addToCart.message.roundUp.title'),
      copy: (count: number, name?: string) =>
        i18NextService.t('cart.addToCart.message.roundUp.copy', { count, context: count && name ? null : 'generic' })
    },
    genericError: {
      headline: i18NextService.t('cart.addToCart.message.genericError.title'),
      copy: i18NextService.t('cart.addToCart.message.genericError.copy')
    }
  })
};
